/**
 * @author tnagorra <weathermist@gmail.com>
 */

export { default } from './Numeral';
export { default as ColoredNumeral } from './ColoredNumeral';



// WEBPACK FOOTER //
// ./src/public/components/View/Numeral/index.js